import React, { useEffect } from 'react';
import PageHeader from '../../../shared/page-header/PageHeader';
import { logAuditEvent } from '../../../utils/auditLogger';
import HomepageBannerTab from './HomepageBannerTab';

function HomepageBannerMain(props) {
  const moduleName = props.Module || 'Homepage Banners';

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Homepage Banners module');
  }, [moduleName]);

  return (
    <>
      <PageHeader
        displayModule={props.Module}
        showAddButton={false}
        showRefresh={false}
        showPDF={false}
        showExcel={false}
        showPrint={false}
      />
      <HomepageBannerTab bannerType="hero" />
    </>
  );
}

export default HomepageBannerMain;
